import DataGridActionHeader from "components/common/controls/grid/DataGridActionHeader";
import ProductEditorPopup from "./ProductEditorPopup";
import { useState } from "react";
import { EditorMode } from "shared/enums/EditorModeEnum";

export default function ManageProductGridActionHeader() {
  const [isCreateNewProductPopupVisible, setIsCreateNewProductPopupVisible] = useState(false);

  const handleCreateNewProductClick = () => {
    setIsCreateNewProductPopupVisible(true);
  };
  const handleCreateNewProductPopupClose = () => {
    setIsCreateNewProductPopupVisible(false);
  };

  return (
    <>
      <DataGridActionHeader
        displayNew={true}
        newButtonText="Add Product"
        onNewClick={handleCreateNewProductClick}
      />
      {isCreateNewProductPopupVisible && (
        <ProductEditorPopup
          onClose={handleCreateNewProductPopupClose}
          mode={EditorMode.Create}
        />
      )}
    </>
  );
};